import api from '@/network';
import { generateId, } from '@/services/Mathe';
import { respExpPlanSingleInputAdapter, PlanMGUUInputAdapter, respondentsAdapter } from '@/adapters/assessmentPlans/expRespPlans.adapter';
import { inputPlanSettings, inputPlanUserNotificationSettings } from '@/adapters/assessmentPlans/planSettings.adapter';
import useToast from "@/components/UI/AppToast/useToast";

export default {
  state: {
    respondents: [],
    respondentsMeta: {},
    assessmentPlan: {},
    planMG: {},
    filters: [],
    PlanEditdataExd: {
      interpritation: [],
      files: [],
    },
    participants: [],
    results: [],
    settings: {},
    notificationSettings: {},
    isLoading: false,
    isDialogActive: false,
    isDialogImportActive: false,
  },

  getters: {
    rows(state) {
      return [
        {
          title: 'Актуальные задания',
          items: state.assessmentPlan?.tests?.active
        },
        {
          title: 'Выполненные задания',
          items: state.assessmentPlan?.tests?.finished
        }
      ]
    },
    rowsMG(state) {

      return {
        testsMG: state.planMG.testsMG,
        currentTestsMG: state.planMG.currentTestsMG,
        countAll: state.planMG?.testsMG?.length,
        countNew: state.planMG?.testsMG?.filter(item => !item.isCompleted).length,
        countCompleted: state.planMG?.testsMG?.filter(item => item.isCompleted).length,

        titles: [
          {
            status: 'all',
            title: 'Все',
          },
          {
            status: 'new',
            title: 'Назначенные',
          },
          {
            status: 'completed',
            title: 'Завершенные',
          }]
      }
    },
    planEditdataExd(state) {
      return state.PlanEditdataExd;
    },
    tests(state) {
      return state.PlanEditdataExd.structure ?? [];
    },
    isOnlyBatteryPlan(state) {
      const structure = state.PlanEditdataExd.structure ?? [];
      return !!structure.length && structure.every(task => task.type === 'battery');
    },
    participants(state) {
      return state.participants;
    },
    interpritation(state) {
      return state.PlanEditdataExd.interpritation ?? [];
    },
    results(state) {
      return state.results;
    },
    settings(state) {
      return state.settings;
    },
    notificationSettings(state) {
      return state.notificationSettings;
    },
  },

  actions: {
    async fetchPlan({ commit }, payload = {}) {
      if(!payload.withoutLoading) commit("setLoading", true);

      const response = await api.get(`plans/${payload.uuid}`, { params: payload.params ? payload.params : null });
      const data = response.data.data;
      if (data) {
        commit('updatePlanStore', data);
        commit('updateExpRespAssessmentPlan', { ...respExpPlanSingleInputAdapter(data), meta: response.data.meta });
        commit("setLoading", false)
        return data
      }
      commit('updatePlanStore', response.data);
      commit('updateExpRespAssessmentPlan', response.data);
      commit("setLoading", false)
    },
    async fetchPlanMG({ commit }, payload = {}) {
      if(!payload.withoutLoading) commit("setLoading", true);

      const response = await api.get(`plans/tests-mguu`);
      const data = response.data.data;

      if (data) {
        commit('updateAssessmentPlanMGUU', { ...PlanMGUUInputAdapter(data), meta: response.data.meta });
        commit('filteredAssessmentPlanMGUU', payload.status ?? 'all');
        commit("setLoading", false)
      }
    },
    async fetchRespondents({ commit }, payload = {}) {
      let path = '';
      if (['expert', 'inspector'].includes(this.getters.authUserRoleSlug)) {
        path = `plans/${payload.uuid}/expert/respondents`;
      } else {
        path = `plans/${payload.uuid}/respondents`;
      }
      const response = await api.get(path, { params: payload.params ?? null });
      const respondents = response.data.data;
      commit('updateRespondents', { respondents: respondentsAdapter(respondents), meta: response.data.meta });
    },
    async fetchPlanUser({ commit }, payload = {}) {
      if(!payload.withoutLoading) commit("setLoading", true);

      const response = await api.get(`plans/user/${payload.uuid}`, { params: payload.params ? payload.params : null });
      const data = response.data.data;
      
      if (data) {
        commit('updatePlanStore', data);
        commit('updateExpRespAssessmentPlan', { ...respExpPlanSingleInputAdapter(data), meta: response.data.meta });
        commit("setLoading", false)
        return data
      }
      commit('updatePlanStore', response.data);
      commit('updateExpRespAssessmentPlan', response.data);
      commit("setLoading", false)
    },
    async completePlan({ commit }, planUuid) {
      await api.put(`/plans/${planUuid}/completed`).then(() => {
        commit('completePlan')
      });
    },
    async resumePlan({ commit }, planUuid) {
      await api.put(`/plans/${planUuid}/resume`).then(() => {
        commit('completePlan', false)
      });
    },
    async fetchPlanSettings({ commit }, { uuid, }) {
      const response = await api.get(`plans/${uuid}/settings`);

      commit('updatePlanSettings', inputPlanSettings(response.data.data));
    },

    async fetchPlanSettingsNotifications({ commit }, { uuid, search, ...pagination }) {
      let params = {
        ...pagination
      };

      if (search) {
        params = {
          ...params,
          settings: {
            value: search,
          },
        };
      }

      const response = await api.get(`plans/${uuid}/user-notifications`, { params, });
      commit('updatePlanNotificationSettings', inputPlanUserNotificationSettings(response.data.data));

      const modifiedData = inputPlanUserNotificationSettings(response.data.data)?.notificationSettings
      return {
        ...response.data,
        data: modifiedData
      };
    },

    async updatePlanSettings({ }, { uuid, payload }) {
      await api.put(`plans/${uuid}/settings`, payload);
    },

    async enableSelfRegistrationLink({ }, { uuid }) {
      const { data } = await api.put(`plans/self_registration/enable`, { uuid });

      return data;
    },

    async disableSelfRegistrationLink({ }, { uuid }) {
      const { data } = await api.put(`plans/self_registration/disable`, { uuid });

      return data;
    },

    async updateSelfRegistrationLink({ state }, { uuid }) {
      const { data } = await api.put(`plans/self_registration/link_update`, {
        uuid
      });

      Object
          .keys(state.settings.selfRegistration)
          .forEach(key => {
            if (state.settings.selfRegistration[key].uuid === data.uuid) {
              state.settings.selfRegistration[key].url = data.url
            }
          })

      return data;
    },

    async updatePlanSettingsNotifications({ state }, { uuid, users }) {
      const response = await api.post(`plans/${uuid}/user-notifications`, users);
      return response.data.data;
    },

    async deletePlan({ }, payload = {}) {
      return await api.delete(`plans/${payload.uuid}`);
    },

    async updatePlan({ }, payload) {
      payload.planFiles = payload.files.map(file => file.uuid);
      return await api.put(`plans/${payload.uuid}`, payload);
    },
    async setPlanStore({ commit, state }, payload = {}) {

      commit('updateStore', {
        entity: 'PlanEditdataExd',
        payload: {
          ...state.PlanEditdataExd,
          ...payload,
        },
      });
    },

    async setPlanEditdataExd(ctx, PlanEditdataExd) {
      ctx.commit('updatePlanEditdataExd', PlanEditdataExd);
    },

    async getPlanProgress({ commit }, payload = {}) {
      const response = await api.get(`plans/${payload.uuid}/progress`);
      commit('SET_PLAN_PROGRESS', { progress: response.data.current_percent });
    },

    async setPlanProgress({ commit }, payload = {}) {
      const response = await api.get(`plans/${payload.uuid}`, { params: payload.params ? payload.params : null });
      commit('SET_PLAN_PROGRESS', respExpPlanSingleInputAdapter(response.data.data));
    },
  },

  mutations: {
    completePlan(state, val = true) {
      state.assessmentPlan.isCompleted = val;
    },
    moveTestToFinished(state, test) {
      test.isConfirmed = true;
      test.isCompleted = true;
      test.btn.label = 'Пройдено';
      state.assessmentPlan.tests.active = state.assessmentPlan.tests.active.filter(item => item.uuid !== test.uuid);
      state.assessmentPlan.tests.finished.unshift(test);
    },
    updateExpRespAssessmentPlan(state, data) {
      state.assessmentPlan = data;
    },

    updateAssessmentPlanMGUU(state, data) {
      state.planMG = data;
    },

    filteredAssessmentPlanMGUU(state, status) {
      switch (status) {
        case 'new': {
          state.planMG.currentTestsMG = state.planMG.testsMG.filter(item => {
            return !item.isCompleted;
          });
          break;
        }
        case 'completed': {
          state.planMG.currentTestsMG = state.planMG.testsMG.filter(item => {
            return item.isCompleted;
          });
          break;
        }
        default: {
          state.planMG.currentTestsMG = state.planMG.testsMG;
          break;
        }
      }
    },

    SET_PLAN_PROGRESS(state, item) {
      state.assessmentPlan.progress = item.progress;
    },
    updatePlanStore(state, payload = {}) {
      state.PlanEditdataExd = {
        ...payload,
        files_expert: []
      };
      if (state.PlanEditdataExd?.structure) {
        state.PlanEditdataExd.structure = state.PlanEditdataExd.structure.map(task => {
          if (task.materials.length) task.files = task.materials
          return task
        })
      }
    },
    updateTests(state, tests) {
      state.PlanEditdataExd.structure = tests;
    },
    updateInterpritation(state, interpritation) {
      state.PlanEditdataExd.interpritation = interpritation;
    },
    updateFilters(state, filters) {
      state.filters = filters;
    },
    updateRespondents(state, { respondents, meta }) {
      state.respondents = respondents;
      state.respondentsMeta = meta;
    },
    updatePlanSettings(state, settings) {
      state.settings = settings;
    },
    updatePlanNotificationSettings(state, notificationSettingsAdapter) {
    state.notificationSettings = notificationSettingsAdapter.notificationSettings;
    },
    updateStore(state, { entity, payload, }) {
      state[entity] = payload;
    },
    setLoading(state, payload) {
      state.isLoading = payload
    },
    updateDialogActive(state, payload) {
      state.isDialogActive = payload
    },
    updateDialogImportActive(state, payload) {
      state.isDialogImportActive = payload
    }
  },
}